import { combineReducers } from 'redux';
import associates from 'store/reducers/associates/associates';
import associatesFilters from 'store/reducers/associates/associatesFilters';
import associatesExcel from 'store/reducers/associates/associatesExcel';

export default combineReducers({
  associates,
  associatesFilters,
  associatesExcel
});